import {
  initializeFirebase,
  getFirebaseAnalytics,
  logEvent,
  getString,
  setUserProperties,
  getAnalytics
} from './javascript-fire-base.js';

const sections = {
  "2.0": [
    "plans-hero",
  ],
  "1.0": [
    "plans-hero-b",
  ],
  "all": [
    "real-customer-stories",
    "shop-with-confidence",
    "reviews",
    "faq"
  ]
}

async function initializePlansPageLayout() {
  try {
    const { firebaseApp, firebaseRemoteConfig } = await initializeFirebase();

    const configuredVersion = getString(firebaseRemoteConfig, "plans_page_version_2");
    const availableVersions = Object.keys(sections).filter(version => version !== "all" && sections[version].some(id => document.getElementById(id)));
    const activePageVersion = availableVersions.includes(configuredVersion) ? configuredVersion : availableVersions[0];
    // const activePageVersion = "2.0"; // Hardcoded for testing purposes

    setUserProperties(getAnalytics(firebaseApp), {
      "firebase_exp_abt_20": activePageVersion
    });

    Object.keys(sections).forEach(version => {
      if (version !== activePageVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[activePageVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.display = "";
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.display = "";
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return activePageVersion;
  } catch (error) {
    console.error("Error fetching remote config, using defaults:", error);

    const latestVersion = Object.keys(sections).filter(version => version !== "all" && sections[version].some(id => document.getElementById(id))).sort().pop();

    Object.keys(sections).forEach(version => {
      if (version !== latestVersion && version !== "all") {
        sections[version].forEach(section => {
          const sectionElement = document.getElementById(section);
          if (sectionElement) {
            sectionElement.style.display = "none";
          }
        });
      }
    });

    sections[latestVersion].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.display = "";
        sectionElement.style.opacity = "1";
      }
    });

    sections["all"].forEach(section => {
      const sectionElement = document.getElementById(section);
      if (sectionElement) {
        sectionElement.style.display = "";
        sectionElement.style.opacity = "1";
      }
    });

    window.scrollTo(0, 0);
    return latestVersion;
  }
}

document.addEventListener('DOMContentLoaded', async () => {
  const primaryCTAs = document.querySelectorAll('.primary-cta');

  const activePageVersion = await initializePlansPageLayout();

  primaryCTAs.forEach(cta => {
    cta.addEventListener('click', () => {
      logEvent(getFirebaseAnalytics(), 'primary_cta_click', {
        source: 'plans_page',
        page_version: activePageVersion
      });
    });
  });
})
